import { useEffect } from "react";
import { useRecoilValue } from "recoil";
import { PromoSession } from "MVVM/State/promoSession";
import { useResolvedPaymentProvider } from "MVVM/Hooks/useResolvedPaymentProvider";

// The live upgrade-page promo, minus Xsolla viewers: promo sale prices are
// Stripe coupons, and Xsolla checkout always charges the plan's list price.
export const useUpgradePagePromo = () => {
  const activePromo = useRecoilValue(PromoSession)?.activeUpgradePagePromo;
  const { provider, resolve } = useResolvedPaymentProvider();

  useEffect(() => {
    resolve();
  }, [resolve]);

  return provider === "xsolla" ? undefined : activePromo;
};
